import { ReactComponent as PuzzleJOYIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_image_puzzle_JOY_line.svg';
import { ReactComponent as TextJOYIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_word_guess_JOY_line.svg';
import { ReactComponent as RegionIcon } from '../assets/graphics/svg/icons/cloud_icon_region_line.svg';
import { ReactComponent as MemberIcon } from '../assets/graphics/svg/icons/cloud_icon_classroom_joined_line_.svg';
import { ReactComponent as MembershipTierIcon } from '../assets/graphics/svg/icons/cloud_icon_classroom_membershipTier_paid_line_.svg';
import { ReactComponent as FriendIcon } from '../assets/graphics/svg/icons/cloud_icon_friends_line_.svg';
import { ReactComponent as GamifiedPostIcon } from '../assets/graphics/svg/icons/cloud_icon_post_gamified_line_.svg';
import { ReactComponent as ArrowIcon } from '../assets/graphics/svg/colorable/cloud_skin02_but_arrow_set4s_00.svg';
import { ReactComponent as TriangleIcon } from '../assets/graphics/svg/colorable/cloud_but_triangle_white.svg';
import { ReactComponent as ReferralIcon } from '../assets/graphics/svg/colorable/cloud_icon_referral_line.svg';
import { ReactComponent as SettingIcon } from '../assets/graphics/svg/colorable/cloud_icon_gear01_line.svg';
import { ReactComponent as MiniTargetIcon } from '../assets/graphics/svg/colorable/cloud_icon_mini_target_line.svg';
import { ReactComponent as MoreIcon } from '../assets/graphics/svg/colorable/cloud_icon_more_line.svg';
import { ReactComponent as ShareIcon } from '../assets/graphics/svg/colorable/cloud_icon_share_out_line.svg';
import { ReactComponent as SuperTargetIcon } from '../assets/graphics/svg/colorable/cloud_icon_super_target_line.svg';
import { ReactComponent as ScoreIcon } from '../assets/graphics/svg/colorable/cloud_scoreboard_game_line.svg';
import { ReactComponent as LogoutIcon } from '../assets/graphics/svg/colorable/setting_page_icon_logout_line.svg';
import { ReactComponent as TimerIcon } from '../assets/graphics/svg/colorable/setting_page_icon_time_management_line.svg';
import { ReactComponent as GameInstructionIcon } from '../assets/graphics/svg/colorable/Game_information_line.svg';
import { ReactComponent as GameTypeJoychessIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_joychess_line.svg';
import { ReactComponent as GameTypeFiveLoavesTwoFishIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_5_loaves_2_fish_line.svg';
import { ReactComponent as GameTypeTicTacToeIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_tic_tac_toe_line.svg';
import { ReactComponent as GameTypeGomokuIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_gomoku_line.svg';
import { ReactComponent as GameConversionIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_conversion_line.svg';
import { ReactComponent as AiIcon } from '../assets/graphics/svg/colorable/cloud_icon_memory_ai_line.svg';
import { ReactComponent as GuranteeIcon } from '../assets/graphics/svg/colorable/cloud_icon_gurantee_line.svg';
import { ReactComponent as StarIcon } from '../assets/graphics/svg/colorable/cloud_icon_favourite_line.svg';
import { ReactComponent as BookGameIcon } from '../assets/graphics/svg/colorable/cloud_icon_book_game_line.svg';
import { ReactComponent as QuickMemoryJoyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_JOYApassage_line.svg';
import { ReactComponent as SpellingJoyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_spelling_line.svg';
import { ReactComponent as ScoreAnalysisIcon } from '../assets/graphics/svg/colorable/report_icon_score_analysis_line.svg';
import { ReactComponent as TranslationIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_translation_line.svg';
import { ReactComponent as TTSIcon } from '../assets/graphics/svg/colorable/cloud_icon_TTS_line.svg';
import { ReactComponent as ImproveIcon } from '../assets/graphics/svg/colorable/cloud_icon_improve_score_line.svg';
import { ReactComponent as FamilyIcon } from '../assets/graphics/svg/colorable/cloud_icon_family_line.svg';
import { ReactComponent as CashIcon } from '../assets/graphics/svg/colorable/cloud_icon_joy_cash_web_line.svg';
import { ReactComponent as HappyIcon } from '../assets/graphics/svg/colorable/cloud_icon_happy_line.svg';
import { ReactComponent as PersonIcon } from '../assets/graphics/svg/colorable/cloud_icon_circle_referred_User.svg';
import { ReactComponent as BrainX9Icon } from '../assets/graphics/svg/icons/cloud_icon_ai_create_game_line.svg';
import { ReactComponent as LanguageAIcon } from '../assets/graphics/svg/icons/cloud_icon_language_a_line.svg';
import { ReactComponent as LanguageQIcon } from '../assets/graphics/svg/icons/cloud_icon_language_q_line.svg';
import { ReactComponent as OCRScanIcon } from '../assets/graphics/svg/icons/cloud_icon_OCR_scan_line.svg';
import { ReactComponent as CameraIcon } from '../assets/graphics/svg/icons/cloud_icon_camera_line.svg';
import { ReactComponent as PictureIcon } from '../assets/graphics/svg/icons/cloud_icon_picture_line.svg';
import { ReactComponent as EditIcon } from '../assets/graphics/svg/icons/cloud_icon_edit_line.svg';

import { ReactComponent as ClickIcon } from '../assets/graphics/svg/icons/cloud_icon_click_line.svg';
import { ReactComponent as SelectAllIcon } from '../assets/graphics/svg/icons/cloud_icon_select_all_line.svg';
import { ReactComponent as SelectSuggestIcon } from '../assets/graphics/svg/icons/cloud_icon_select_suggest_line.svg';
import { ReactComponent as TutorGamesIcon } from '../assets/graphics/svg/icons/cloud_icon_tutor_games_line.svg';
import { ReactComponent as JourneyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_Set_album_line.svg';
import { ReactComponent as Arrow5Icon } from '../assets/graphics/svg/icons/cloud_skin02_but_arrow_set5.svg';
import { ReactComponent as BubbleIndicatorIcon } from '../assets/graphics/svg/icons/cloud_icon_progress_indicator_shape.svg';
import { ReactComponent as SquareCheckboxEmptyIcon } from '../assets/graphics/svg/icons/button_square_empty.svg';
import { ReactComponent as SquareCheckboxTickIcon } from '../assets/graphics/svg/icons/button_square_tick_ddgreen.svg';
import { ReactComponent as CircleCheckboxTickIcon } from '../assets/graphics/svg/icons/cloud_icon_confirm_ddgreen.svg';
import { ReactComponent as TickIcon } from '../assets/graphics/svg/icons/cloud_icon_tick.svg';
import { ReactComponent as CircleCheckboxEmptyIcon } from '../assets/graphics/svg/icons/button_circle_empty.svg';
import { ReactComponent as CircleCrossIcon } from '../assets/graphics/svg/icons/cloud_icon_circle_cross.svg';
import { ReactComponent as DirectArrowIcon } from '../assets/graphics/svg/icons/cloud_icon_arrow_white.svg';
import { ReactComponent as MemoryWithoutAIIcon } from '../assets/graphics/svg/icons/cloud_icon_memory_without_ai_line.svg';
import { ReactComponent as MemoryWithAIIcon } from '../assets/graphics/svg/icons/cloud_icon_memory_ai_line.svg';
import { ReactComponent as PlayIcon } from '../assets/graphics/svg/icons/cloud_but_play_line.svg';
import { ReactComponent as PeriodIcon } from '../assets/graphics/svg/icons/report_icon_period_line.svg';
import { ReactComponent as BubbleShapeIcon } from '../assets/graphics/svg/colorable/BubbleShape_Game.svg';
import { ReactComponent as DoubleClockIcon } from '../assets/graphics/svg/colorable/setting_page_icon_total_usage_time_line.svg';
import { ReactComponent as DoubleScoreIcon } from '../assets/graphics/svg/colorable/cloud_icon_total_score_line.svg';

import { ReactComponent as PlayerPauseIcon } from '../assets/graphics/svg/icons/cloud_but_player_pause.svg';
import { ReactComponent as PlayerPlayIcon } from '../assets/graphics/svg/icons/cloud_but_player_play.svg';
import { ReactComponent as PlayerStopIcon } from '../assets/graphics/svg/icons/cloud_but_player_stop.svg';
import { ReactComponent as CircleBackIcon } from '../assets/graphics/svg/icons/cloud_icon_circle_back_shade.svg';
import { ReactComponent as GameIcon } from '../assets/graphics/svg/icons/cloud_icon_games_line.svg';

import { ReactComponent as CircleTickIcon } from '../assets/graphics/svg/colorable/circle_tick_colorable.svg';
import { ReactComponent as CircleTick2Icon } from '../assets/graphics/svg/colorable/circle_tick_colorable2.svg';
import { ReactComponent as ConfirmTickIcon } from '../assets/graphics/svg/icons/Game_tick_confrim_line.svg';
import { ReactComponent as RedCrossIcon } from '../assets/graphics/svg/icons/cloud_icon_cross.svg';
import { ReactComponent as DoublePersonIcon } from '../assets/graphics/svg/colorable/cloud_icon_friends_line_.svg';
import { ReactComponent as PreviewHideIcon } from '../assets/graphics/svg/icons/cloud_icon_preview_hide_line.svg';
import { ReactComponent as PreviewShowIcon } from '../assets/graphics/svg/icons/cloud_icon_preview_line.svg';

export enum SVGIconType {
  PuzzleJOY = 'PuzzleJOY',
  TextJOY = 'TextJOY',

  Region = 'Region',
  Member = 'Member',
  Friend = 'Friend',
  MembershipTier = 'MembershipTier',

  GamifiedPost = 'GamifiedPost',
  BubbleShape = 'BubbleShape',

  Arrow = 'Arrow',
  Triangle = 'Triangle',
  Referral = 'Referral',
  GameInstruction = 'GameInstruction',
  Setting = 'Setting',
  MiniTarget = 'MiniTarget',
  More = 'More',
  Share = 'Share',
  SuperTarget = 'SuperTarget',
  Score = 'Score',
  Logout = 'Logout',
  Timer = 'Timer',
  JOYChess = 'JOYChess',
  FiveLoavesTwoFish = 'FiveLoavesTwoFish',
  TicTacToe = 'TicTacToe',
  Gomoku = 'Gomoku',
  Conversion = 'Conversion',
  Ai = 'Ai',
  Gurantee = 'Gurantee',
  Star = 'Star',
  BookGame = 'BookGame',
  QuickMemoryJoy = 'QuickMemoryJoy',
  SpellingJoy = 'SpellingJoy',
  ScoreAnalysis = 'ScoreAnalysis',
  Translation = 'Translation',
  TTS = 'TTS',
  Improve = 'Improve',
  Family = 'Family',
  Cash = 'Cash',
  Happy = 'Happy',
  Person = 'Person',
  BrainX9 = 'BrainX9',
  LanguageA = 'LanguageA',
  LanguageQ = 'LanguageQ',
  OCRScan = 'OCRScan',
  Camera = 'Camera',
  Picture = 'Picture',
  Edit = 'Edit',
  Click = 'Click',
  SelectAll = 'SelectAll',
  SelectSuggest = 'SelectSuggest',
  TutorGames = 'TutorGames',
  Journey = 'Journey',
  Arrow5 = 'Arrow5',
  BubbleIndicator = 'BubbleIndicator',
  SquareCheckboxEmpty = 'SquareCheckboxEmpty',
  SquareCheckboxTick = 'SquareCheckboxTick',
  CircleCheckboxEmpty = 'CircleCheckboxEmpty',
  CircleCheckboxTick = 'CircleCheckboxTick',
  Tick = 'Tick',
  CircleCross = 'CircleCross',
  DirectArrow = 'DirectArrow',
  MemoryWithoutAI = 'MemoryWithoutAI',
  MemoryWithAI = 'MemoryWithAI',
  Play = 'Play',
  Period = 'Period',
  PlayerPause = 'PlayerPause',
  PlayerPlay = 'PlayerPlay',
  PlayerStop = 'PlayerStop',
  DoubleClock = 'DoubleClock',
  DoubleScore = 'DoubleScore',
  CircleBack = 'CircleBack',
  Game = 'Game',
  CircleTick = 'CircleTick',
  CircleTick2 = 'CircleTick2',
  ConfirmTick = 'ConfirmTick',
  RedCross = 'RedCross',
  DoublePerson = 'DoublePerson',
  PreviewHide = 'PreviewHide',
  PreviewShow = 'PreviewShow',
}

// SVG Line Icons
export const svgIcons = {
  PuzzleJOY: PuzzleJOYIcon,
  TextJOY: TextJOYIcon,
  //
  Region: RegionIcon,
  Member: MemberIcon,
  Friend: FriendIcon,
  MembershipTier: MembershipTierIcon,
  //
  Arrow: ArrowIcon,
  Triangle: TriangleIcon,
  Referral: ReferralIcon,
  GameInstruction: GameInstructionIcon,
  Setting: SettingIcon,
  MiniTarget: MiniTargetIcon,
  More: MoreIcon,
  Share: ShareIcon,
  SuperTarget: SuperTargetIcon,
  Score: ScoreIcon,
  Logout: LogoutIcon,
  Timer: TimerIcon,
  //
  GamifiedPost: GamifiedPostIcon,
  BubbleShape: BubbleShapeIcon,
  //
  JOYChess: GameTypeJoychessIcon,
  FiveLoavesTwoFish: GameTypeFiveLoavesTwoFishIcon,
  TicTacToe: GameTypeTicTacToeIcon,
  Gomoku: GameTypeGomokuIcon,
  Conversion: GameConversionIcon,
  //
  Ai: AiIcon,
  Gurantee: GuranteeIcon,
  Star: StarIcon,
  BookGame: BookGameIcon,
  QuickMemoryJoy: QuickMemoryJoyIcon,
  SpellingJoy: SpellingJoyIcon,
  ScoreAnalysis: ScoreAnalysisIcon,
  Translation: TranslationIcon,
  TTS: TTSIcon,
  Improve: ImproveIcon,
  Family: FamilyIcon,
  Cash: CashIcon,
  Happy: HappyIcon,
  Person: PersonIcon,
  //
  BrainX9: BrainX9Icon,
  LanguageA: LanguageAIcon,
  LanguageQ: LanguageQIcon,
  OCRScan: OCRScanIcon,
  Camera: CameraIcon,
  Picture: PictureIcon,
  Edit: EditIcon,
  Click: ClickIcon,
  SelectAll: SelectAllIcon,
  SelectSuggest: SelectSuggestIcon,
  TutorGames: TutorGamesIcon,
  Journey: JourneyIcon,
  Arrow5: Arrow5Icon,
  BubbleIndicator: BubbleIndicatorIcon,
  SquareCheckboxEmpty: SquareCheckboxEmptyIcon,
  SquareCheckboxTick: SquareCheckboxTickIcon,
  CircleCheckboxTick: CircleCheckboxTickIcon,
  Tick: TickIcon,
  CircleCheckboxEmpty: CircleCheckboxEmptyIcon,
  CircleCross: CircleCrossIcon,
  DirectArrow: DirectArrowIcon,
  MemoryWithAI: MemoryWithAIIcon,
  MemoryWithoutAI: MemoryWithoutAIIcon,
  Play: PlayIcon,
  Period: PeriodIcon,
  PlayerPause: PlayerPauseIcon,
  PlayerPlay: PlayerPlayIcon,
  PlayerStop: PlayerStopIcon,
  DoubleClock: DoubleClockIcon,
  DoubleScore: DoubleScoreIcon,
  CircleBack: CircleBackIcon,
  Game: GameIcon,
  CircleTick: CircleTickIcon,
  CircleTick2: CircleTick2Icon,
  ConfirmTick: ConfirmTickIcon,
  RedCross: RedCrossIcon,
  DoublePerson: DoublePersonIcon,
  PreviewHide: PreviewHideIcon,
  PreviewShow: PreviewShowIcon,
};

export type SVGIconName = keyof typeof svgIcons;
